<!-- @Author Shyam @Date 26/03/2026 @Description:Placeholder workflow step Component -->
<div class="topdiv compact-container">
  <!-- Header -->
  <div class="row mb-1">
    <div class="col-lg">
      <label class="textColour compact-title">Placeholder Step</label>
    </div>
  </div>

  <form novalidate [formGroup]="validations_form">
    <div class="row compact-row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="compact-field">
          <mat-label>Create New Step</mat-label>

          <input
            matInput
            formControlName="stepname"
            placeholder="Enter Step Name"
          />

          <mat-error
            *ngIf="validations_form.get('stepname')?.hasError('required')"
            >Stepname is required</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <!-- Buttons -->
    <div class="compact-actions">
      <app-common-button
        label="Create"
        title="Create"
        [critical]="false"
        [buttonId]="1111"
        width="130px"
        (clicked)="save()"
        height="34px"
        style="margin-left: 6px; margin-right: 6px; color: white"
      >
      </app-common-button>

      <app-common-button
        label="Cancel"
        title="Cancel"
        [critical]="false"
        [buttonId]="1111"
        variant="cancel"
        width="130px"
        (clicked)="cancel()"
        height="34px"
        style="
          margin-left: 6px;
          margin-right: 6px;
          color: white;
          padding: 0.3rem 1.6rem;
          font-size: 0.85rem;
        "
      >
      </app-common-button>
    </div>
  </form>
</div>
